import { useEffect, useRef, useState } from "react";
import { Icon } from "./Icons";

/** Draw-to-sign canvas. Calls onChange with a PNG data URI after each stroke,
 *  or null when cleared. */
export function SignaturePad({ onChange }: { onChange: (dataUri: string | null) => void }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const drawing = useRef(false);
  const dirty = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current; if (!c) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = c.getBoundingClientRect();
    c.width = rect.width * dpr; c.height = rect.height * dpr;
    const ctx = c.getContext("2d")!;
    ctx.scale(dpr, dpr);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#1a1714";
  }, []);

  function pos(e: React.PointerEvent) {
    const r = ref.current!.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  }
  function down(e: React.PointerEvent) { drawing.current = true; const ctx = ref.current!.getContext("2d")!; const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); ref.current!.setPointerCapture(e.pointerId); }
  function move(e: React.PointerEvent) { if (!drawing.current) return; const ctx = ref.current!.getContext("2d")!; const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); dirty.current = true; if (empty) setEmpty(false); }
  function up() { if (!drawing.current) return; drawing.current = false; if (dirty.current) onChange(ref.current!.toDataURL("image/png")); }
  function clear() { const c = ref.current!; c.getContext("2d")!.clearRect(0, 0, c.width, c.height); dirty.current = false; setEmpty(true); onChange(null); }

  return (
    <div>
      <div style={{ position: "relative", border: "1px solid var(--line-2)", borderRadius: 12, background: "var(--card)", overflow: "hidden" }}>
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          style={{ width: "100%", height: 150, display: "block", touchAction: "none", cursor: "crosshair" }} />
        {empty && <div className="dim" style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", pointerEvents: "none", fontSize: 13 }}>Sign here</div>}
        <div style={{ position: "absolute", left: 16, right: 16, bottom: 24, height: 1, background: "var(--line)" }} />
      </div>
      <button className="chip" style={{ marginTop: 8, fontSize: 12 }} onClick={clear}><Icon.close width={12} />Clear</button>
    </div>
  );
}
